import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GenericFunctionsUtil} from '@core/src/lib/utils/generic-functions.util';

@Component({
  selector: 'si-email-verification-dialog',
  templateUrl: './email-verification-dialog.component.html',
  styleUrls: ['./email-verification-dialog.component.scss']
})
export class EmailVerificationDialogComponent {
  @Input() displayDialog: boolean;
  @Input() emailValue: string;
  @Input() emailVerificationCode: string;
  @Input() emailVerificationErrorText: string;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() emailVerificationCodeChange = new EventEmitter<string>();
  GenericFunctionsUtil = GenericFunctionsUtil;

  onChangeDisplayDialog(displayDialog: boolean): void {
    this.displayDialogChange.emit(displayDialog);
  }

  onClickValidate(): void {
    this.emailVerificationCodeChange.emit(this.emailVerificationCode);
  }
}
